import './index.scss'
$(".product-nav dl dt").click(function() {
    $(this).toggleClass("active");
    $(this).parent().find(".dd").slideToggle();
})
